import { render, staticRenderFns } from "./MemogeniusSystemIntroPopup.vue?vue&type=template&id=0653f8f4&scoped=true&"
import script from "./MemogeniusSystemIntroPopup.vue?vue&type=script&lang=js&"
export * from "./MemogeniusSystemIntroPopup.vue?vue&type=script&lang=js&"
import style0 from "./MemogeniusSystemIntroPopup.vue?vue&type=style&index=0&id=0653f8f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0653f8f4",
  null
  
)

export default component.exports